// TODO: REVISAR SI INTERESA PARA CASOS TIPO RESPONSIVE TABLA
export enum ClassResponsiveEnum {
  OcultarXs = 'hidden-xs',
  OcultarLg = 'hidden-lg',
  OcultarAPartirDeLg = 'lg',
  OcultarAPartirDeMd = 'md',
  OcultarAPartirDeSm = 'sm',
  OcultarAPartirDeXs = 'xs'
}
